import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  LanguageConfig,
  NavigationConfiguration,
  NavigationStateData,
} from '@zipari/shared-ds-util-navigation';

@Component({
  selector: 'nav-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
  @Input() config: NavigationConfiguration;
  @Input() activeLangKey: string;
  @Input() data: NavigationStateData;

  @Output() dropdownOptionSelected = new EventEmitter<object>();
  @Output() languageSwitched = new EventEmitter<string>();
  @Output() navItemClicked = new EventEmitter<string>();
  @Output() navMenuClicked = new EventEmitter<string>();

  selectOption(option: object): void {
    this.dropdownOptionSelected.emit(option);
  }

  handleSwitchLanguageClicked(lang: LanguageConfig): void {
    this.languageSwitched.emit(lang.key);
  }
}
